var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 9.53125C7.32843 9.53125 8 8.85968 8 8.03125C8 7.20282 7.32843 6.53125 6.5 6.53125C5.67157 6.53125 5 7.20282 5 8.03125C5 8.85968 5.67157 9.53125 6.5 9.53125Z",
    fill: "#C3CAD0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 3.69922C7.32843 3.69922 8 3.02765 8 2.19922C8 1.37079 7.32843 0.699219 6.5 0.699219C5.67157 0.699219 5 1.37079 5 2.19922C5 3.02765 5.67157 3.69922 6.5 3.69922Z",
    fill: "#C3CAD0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 15.3672C7.32843 15.3672 8 14.6956 8 13.8672C8 13.0388 7.32843 12.3672 6.5 12.3672C5.67157 12.3672 5 13.0388 5 13.8672C5 14.6956 5.67157 15.3672 6.5 15.3672Z",
    fill: "#C3CAD0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9.53125C2.32843 9.53125 3 8.85968 3 8.03125C3 7.20282 2.32843 6.53125 1.5 6.53125C0.671573 6.53125 0 7.20282 0 8.03125C0 8.85968 0.671573 9.53125 1.5 9.53125Z",
    fill: "#C3CAD0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3.69922C2.32843 3.69922 3 3.02765 3 2.19922C3 1.37079 2.32843 0.699219 1.5 0.699219C0.671573 0.699219 0 1.37079 0 2.19922C0 3.02765 0.671573 3.69922 1.5 3.69922Z",
    fill: "#C3CAD0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 15.3672C2.32843 15.3672 3 14.6956 3 13.8672C3 13.0388 2.32843 12.3672 1.5 12.3672C0.671573 12.3672 0 13.0388 0 13.8672C0 14.6956 0.671573 15.3672 1.5 15.3672Z",
    fill: "#C3CAD0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.de05e0f18415cd41a0b8f5203502a765.svg";
export { ForwardRef as ReactComponent };